export default __webpack_public_path__ + "static/media/Poppins-Medium.9e1bb626.ttf";